import React from "react";
import { Routes, Route } from "react-router-dom";
import "./global.css";
import HomePage from "./components/HomePage";
import CallbackPage from "./components/CallbackPage";

export default function App() {

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/callback" element={<CallbackPage />} />
      </Routes>
    </>
  );

}